import React, {useState, useEffect} from "react"

// data
import data from "../../../../data"

// components
import Features from "./Features"

// the component
function Regions({activity}) {
  // state
  const [items, setItems] = useState([])

  // side effects
  useEffect(() => {
    // get items
    let wnsItems = activity.regionVariants
      .filter(rv => rv.isActive)
      .map(rv => {
        let areas = ""
        if((rv.availableAreas || "").trim().length > 0) {
          areas = ` (${rv.availableAreas.trim()})`
        }
        let text = data.Regions.getTitle(rv.regionCode, "de") + areas
        
        return {key:rv.regionCode, text}
      })

    // update the state
    setItems(wnsItems)
  }, [activity])

  // render
  if(items.length === 0) {
    return null
  }
  else {
    let text = null
    if(activity.isHomeDelivery) {
      // TODO homedelivery, texts
      text = "Diese Überraschung wird direkt nach Hause zum Beschenkten geliefert. Die meisten Heimlieferdienste sind nur in Stadt-Gebieten verfügbar."
    }
    return (
      <Features 
        title="Verfügbare Regionen" 
        text={text}
        items={items}
      />
    )
  }
}

export default Regions